import React, { useEffect, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Export from "../../component/Export";
// import "katex/dist/katex.min.css";
// var Latex = require("react-latex");
import "mathlive";

const ViewMcqs = () => {
  const latexString = "E = mc^2";
  const latexEquation = "\\frac{a}{b}";
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  // const [sectionData, setSectionData] = useState({});
  const [sectionData, setSectionData] = useState({
    optional_enable: 0, // Default to unchecked
    optional_for: "any", // Default dropdown value
    optional_number: "", // Default value for number input
    optional_instruction: "", // Default instruction input value
  });
  const [selectedMcqs, setSelectedMcqs] = useState([]);
  const [mcqBank, setMcqBank] = useState({
    selectedBankId: "",
    selectedBankTxt: "",
    queBanks: [],
  });
  const token = config.token;
  const navigate = useNavigate();
  const { base, id, upfrom } = useParams();
  const optionHead = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
  ];

  const handleMcqBank = (e) => {
    const selectedIndex = e.target.selectedIndex;
    const selectedOption = e.target.options[selectedIndex];
    const selectedText = selectedOption.textContent;

    setMcqBank((prevData) => ({
      ...prevData,
      selectedBankId: e.target.value,
      selectedBankTxt: selectedText,
    }));
    getQuestions(e.target.value);
  };

  const handleCheckboxChange = (mcqId) => {
    setSelectedMcqs((prevSelectedMcqs) => {
      if (prevSelectedMcqs.includes(mcqId)) {
        return prevSelectedMcqs.filter((id) => id !== mcqId);
      } else {
        return [...prevSelectedMcqs, mcqId];
      }
    });
  };
  // const handleSectionValChange = (e) => {
  //   setSectionData((prevData) => ({
  //     ...prevData,
  //     [e.target.name]: e.target.value,
  //   }));
  // };
  const handleSectionValChange = (e) => {
    const { name, value } = e.target;
    setSectionData((prevData) => ({
      ...prevData,
      [name]: value, // Update the state with the new value
    }));
  };
  const handleOptinalBtn = () => {
    setSectionData((prevData) => ({
      ...prevData,
      optional_enable: prevData.optional_enable === 1 ? 0 : 1, // Toggle optional_enable
    }));
  };
  const handleTimerBtn = () => {
    setSectionData((prevData) => ({
      ...prevData,
      timer: "0",
      set_timer:
        sectionData.set_timer === "1" || sectionData.set_timer === 1
          ? "0"
          : "1",
    }));
  };

  useEffect(() => {
    console.log(sectionData);
  }, [sectionData]);
  //----------------------------------------------- get section data ----------------------------------------------r
  const getSectionData = async (esid) => {
    setSectionData({});
    setLoadingModal(true);
    try {
      await fetch(`${config.host_url}mcq/exam-section/${esid}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            console.log(data.data);
            setSectionData(data.data);
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching data");
    } finally {
      setLoadingModal(false);
    }
  };

  //----------------------------------------------- edit section data ----------------------------------------------u
  const handleEditSectionBtn = async (id) => {
    try {
      await fetch(`${config.host_url}mcq/exam-section/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(sectionData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "Section updated successfully.");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          console.error("Fetch error:", error);
        });
    } catch (error) {
      triggerNotification("error", "Error updating section");
    }
  };
  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () => {
    return questions.map((question) => {
      const data = {
        Question: question.que,
        Question_file: question.que_file,
        Explanation: question.explanation,
        Answer: question.ans,
        que_type: question.que_type,
      };

      question.options.forEach((option, index) => {
        data[`option_${String.fromCharCode(65 + index)}`] = option;
      });

      return data;
    });
  };
  //------------------------------------------ select / get question ------------------------------------------
  const getQuestions = async (mbid) => {
    if (mbid !== "") {
      setLoading(true);
      setQuestions([]);
      try {
        await fetch(`${config.host_url}mcq?mbid=${mbid}&from=mcq`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              console.log("data is", data.data);

              setQuestions(data.data);
              const sectionListData = data.sections.map((section, i) => ({
                section: section,
                esid: data.esid[i],
              }));
              setSectionList(sectionListData);
            } else if (data.status === 401) {
              triggerNotification("error", "Unauthenticated user");
            } else {
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!!"
              );
            }
          });
      } catch (error) {
        triggerNotification("error", "Error fetching data");
      } finally {
        setLoading(false);
      }
    }
  };

  const getQuestionBank = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}mcqbanks/${base}/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setMcqBank({
              selectedBankId: "",
              selectedBankTxt: "",
              queBanks: data.data,
            });
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getQuestionBank();
    // getQuestions();
  }, [token]);

  // ------------------------------------------------------------------ Delete Questions -----------------------------------------------------D
  const showDeleteConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete selected MCQs. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete();
      }
    });
  };

  //Confirm delete
  const handleDelete = async () => {
    try {
      await fetch(`${config.host_url}mcq`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ ids: selectedMcqs }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          if (data.status === 200) {
            triggerNotification("success", "MCQs deleted successfully");
            setSelectedMcqs([]);
            getQuestions(mcqBank.selectedBankId);
          } else if (data.status === 404) {
            triggerNotification("error", "MCQ IDs not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting MCQs");
    }
  };

  // ------------------------------------------------------------------ Edit Questions -----------------------------------------------------D
  const handleEditBtn = (mcqid, sec) => {
    const adfrom = upfrom;
    navigate(
      `/addmcq/${mcqid}/${id}/${base}/${adfrom}/sec/${sec}/mbid/${mcqBank.selectedBankId}?from=mcq`
    );
  };

  return (
    <>
      {base === "course" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={[
            "View Courses",
            `View MCQs - ${decodeURIComponent(atob(upfrom))}`,
          ]}
          url={["/viewcourses"]}
        />
      ) : (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={[
            "View Chapters",
            `View MCQs - ${decodeURIComponent(atob(upfrom))}`,
          ]}
          url={["/viewchapters"]}
        />
      )}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">
              View MCQs - {decodeURIComponent(atob(upfrom))}
            </h5>
            <div>
              <Export
                onExport={handleExport}
                mcq={decodeURIComponent(atob(upfrom))}
                bank={mcqBank.selectedBankTxt}
              />
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate(
                    `/addmcq/${base}/${id}/${upfrom}${mcqBank.selectedBankId &&
                    `/mbid/${btoa(
                      encodeURIComponent(mcqBank.selectedBankId)
                    )}`
                    }`
                  );
                }}
              >
                Add MCQ
              </button>
            </div>
          </div>
          <hr />
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-5 mt-3 pb-3">
              <div className="col-md-12 mt-2">
                <div className="form-floating form-floating-outline mb-4">
                  <select
                    className="form-select mx-auto"
                    id="quebankdropdown"
                    aria-label="quebankdropdown"
                    value={mcqBank.selectedBankId}
                    onChange={handleMcqBank}
                  >
                    <option value="" disabled selected className="text-center">
                      --- Select Question Bank ---
                    </option>
                    {mcqBank.queBanks &&
                      mcqBank.queBanks.map((queBank) => (
                        <option key={queBank.mbid} value={queBank.mbid}>
                          {queBank.bank_name}
                        </option>
                      ))}
                  </select>

                  <label htmlFor="quebankdropdown">Question Bank</label>
                </div>
              </div>
              {sectionList && sectionList.length > 0 ? (
                <div className="card mb-4">
                  <div className="card-header p-0">
                    <div className="nav-align-top">
                      <ul className="nav nav-tabs" role="tablist">
                        {sectionList.map((section, i) => (
                          <li className="nav-item" key={i}>
                            <button
                              type="button"
                              className={`nav-link ${i === 0 && "active"} `}
                              role="tab"
                              data-bs-toggle="tab"
                              data-bs-target={`#navs-top-${section.section}`}
                              aria-controls={`navs-top-${section.section}`}
                              aria-selected={i === 0 ? "true" : "false"}
                            >
                              {section.section}
                              <span
                                className="mdi mdi-pencil ml-4"
                                data-bs-toggle="modal"
                                data-bs-target="#editSecModal"
                                onClick={() => getSectionData(section.esid)}
                              ></span>
                              {/* <span className="mdi mdi-delete ml-2"></span> */}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="tab-content p-0">
                      {sectionList.map((section, index) => (
                        <div
                          key={index}
                          className={`tab-pane fade ${index === 0 && "show active"
                            } `}
                          id={`navs-top-${section.section}`}
                          role="tabpanel"
                        >
                          {/* -------- */}
                          {questions[section.section]?.map((question, i) => (
                            <div key={i}>
                              <div className="flex item-center">
                                <div>
                                  <input
                                    className="form-check-input mr-5"
                                    type="checkbox"
                                    value=""
                                    id={`customCheckboxMcq${i}`}
                                    onChange={() =>
                                      handleCheckboxChange(question.mcqid)
                                    }
                                    checked={selectedMcqs.includes(
                                      question.mcqid
                                    )}
                                  />
                                </div>
                                <label htmlFor={`customCheckboxMcq${i}`}>
                                  <h5 className="select-none">
                                    {i + 1}.{" "}
                                    {question.isFormula === 1 ? (
                                      // <Latex>{ question?.que}</Latex>
                                      <>
                                        <math-field disabled>
                                          {" "}
                                          {question.que}
                                        </math-field>
                                      </>
                                    ) : question.que_file ? (
                                      <div className="mt-2">
                                        <img
                                          src={question.que_file} // Ensure this is the correct URL for the image
                                          alt="Uploaded file"
                                          className="img-fluid" // Add classes for styling
                                          style={{ maxWidth: '100%', height: 'auto' }} // Responsive styling
                                        />
                                      </div>
                                    ) : (
                                      question.que.replace(
                                        /\{dash\}/g,
                                        "__________"
                                      )
                                    )}
                                  </h5>
                                </label>
                                <div className="tooltip-container">
                                  <i
                                    className="menu-icon tf-icons mdi mdi-tooltip-edit col ml-4"
                                    data-toggle="tooltip"
                                    title="Edit"
                                    onClick={() => {
                                      handleEditBtn(
                                        question.mcqid,
                                        section.section
                                      );
                                    }}
                                  ></i>
                                </div>
                              </div>

                              {/* explanation */}
                              {question.explanation && (
                                <div className="flex select-none ml-14 ">
                                  <h6 className="mr-2">Explanation :</h6>
                                  <h6 className="text-slate-950/50">
                                    {question.explanation}
                                  </h6>
                                </div>
                              )}

                              {/* explanation file*/}
                              {question.explanation_file && (
                                <div className="flex select-none ml-14 ">
                                  <h6 className="mr-2">
                                    {"Explanation File :"}
                                  </h6>
                                  <h6 className="text-slate-950/50">
                                    <a
                                      href={question.explanation_file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                                    >
                                      Open
                                    </a>
                                  </h6>
                                </div>
                              )}

                              {/* mark | negative mark */}
                              <div className="ml-14 ">
                                <div className="row">
                                  <div className="col-md-6 flex select-none">
                                    <h6 className="mr-2">Mark :</h6>
                                    <h6 className="text-slate-950/50">
                                      {question.positive_mark}
                                    </h6>
                                  </div>
                                  <div className="col-md-6 flex select-none">
                                    <h6 className="mr-2">Negative Mark :</h6>
                                    <h6 className="text-slate-950/50">
                                      {question.negative_mark}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              {/* words include | words not include*/}
                              {question.que_type === "Short" && (
                                <div className="ml-14 ">
                                  <div className="row">
                                    <div className="col-md-6 flex select-none">
                                      <h6 className="mr-2">Words Include :</h6>
                                      <h6 className="text-slate-950/50">
                                        {question.word_include?.replaceAll(
                                          "@#$",
                                          ", "
                                        )}
                                      </h6>
                                    </div>
                                    <div className="col-md-6 flex select-none">
                                      <h6 className="mr-2">
                                        Words Not Include :
                                      </h6>
                                      <h6 className="text-slate-950/50">
                                        {question.word_not_include?.replaceAll(
                                          "@#$",
                                          ", "
                                        )}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* option */}
                              <div className="ml-14">
                                <div className="row">
                                  {(question.options && question.options.length > 0) || (question.options_file && question.options_file.length > 0) ? (
                                    <>
                                      {question.options && question.options.length > 0 && question.options.every(option => ["a", "b", "c", "d"].includes(option)) ? (
                                        question.options_file && question.options_file.length > 0 && question.options_file.map((option, j) => (
                                          <div className="col-md-6 flex pr-28" key={j}>
                                            <span className="mr-2 pb-0 mb-0">
                                              {optionHead[j]} {") "}
                                            </span>
                                            <span className="flex flex-column">
                                              <img
                                                src={option}
                                                alt={`Option File ${j}`}
                                                className="img-fluid mb-1"
                                                style={{ maxWidth: '100%', height: 'auto' }}
                                              />
                                            </span>
                                          </div>
                                        ))) : (
                                        question.options.map((option, j) => (
                                          <div className="col-md-6 flex pr-28" key={j}>
                                            <span className="mr-2 pb-0 mb-0">
                                              {optionHead[j]} {") "}
                                            </span>
                                            <span className="flex flex-column">
                                              <span>{option.text || option}</span>
                                            </span>
                                          </div>
                                        ))
                                      )}
                                      {!(question.options && question.options.length > 0 && question.options.every(option => ["a", "b", "c", "d"].includes(option))) &&
                                        question.options_file && question.options_file.length > 0 && question.options_file.map((option, j) => (
                                          option.options_file ? (
                                            <div className="col-md-6 flex pr-28" key={j}>
                                              <span className="mr-2 pb-0 mb-0">
                                                {optionHead[j]} {") "}
                                              </span>
                                              <span className="flex flex-column">
                                                <img
                                                  src={option.options_file}
                                                  alt={`Option File ${j}`}
                                                  className="img-fluid mb-1"
                                                  style={{ maxWidth: '100%', height: 'auto' }}
                                                />
                                                <span>{option.text || "No description available"}</span>
                                              </span>
                                            </div>
                                          ) : null
                                        ))
                                      }
                                    </>
                                  ) : (
                                    <p>No options available</p>
                                  )}
                                  <span className="flex pl-0">
                                    <h6 className="mr-2">Answer :</h6>
                                    <h6 className="text-slate-950/50">
                                      {question.que_type === "Match the pair"
                                        ? question.ans
                                          .replace(/\@\#\$/g, " => ")
                                          .replace(/\$\#\@/g, " | ")
                                        : question.ans.replace(/\@\#\$/g, ", ")}
                                    </h6>
                                  </span>
                                  <span className="flex mt-0 pl-0">
                                    <h6 className="mr-2">Question Type :</h6>
                                    <h6 className="text-slate-950/50">{question.que_type}</h6>
                                  </span>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                          {/* ============= */}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : mcqBank.selectedBankId ? (
                <p className="text-center">
                  There are currently no questions available within this
                  question bank.
                </p>
              ) : (
                <p className="text-center">
                  Please choose a question bank to view its associated
                  questions.
                </p>
              )}
              <div className="flex justify-end">
                {selectedMcqs.length > 0 && (
                  <button
                    type="button"
                    className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                    onClick={showDeleteConfirmation}
                  >
                    Delete Selected
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* //----------------------------------------------- popup ----------------------------- */}
      <div
        className="modal "
        id={`editSecModal`}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple  modal-lg modal-add-new-cc">
          <div className="modal-content pb-2">
            <div className="modal-body p-md-0">
              <h5 className="card-header p-0 pb-3">Description</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="row border rounded p-2 mb-2">
                {loadingModal ? (
                  <Spinner />
                ) : (
                  <>
                    <div className=" p-2">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          className="form-control "
                          name="section"
                          id="section"
                          placeholder="Enter a section "
                          value={sectionData.section}
                          onChange={handleSectionValChange}
                        />
                        <label htmlFor="section"> Enter a section </label>
                      </div>
                      <div className="row mt-3 ">
                        <div className="col-sm-3 ">
                          <div
                            className=" select-none"
                            id="examTimer"
                            name="examTimer"
                            onClick={handleTimerBtn}
                          >
                            {sectionData.set_timer === "1" ||
                              sectionData.set_timer === 1 ? (
                              <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                            ) : (
                              <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                            )}
                            <span>Set Timer</span>
                            <span
                              style={{
                                visibility: sectionData.set_timer
                                  ? "hidden"
                                  : "visible",
                              }}
                            >
                              ?
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-9">
                          {(sectionData.set_timer === "1" ||
                            sectionData.set_timer === 1) && (
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  min="1"
                                  className="form-control mb-0"
                                  name="timer"
                                  id="timer"
                                  placeholder=" Exam Time (In Minutes) "
                                  value={sectionData.timer}
                                  onChange={handleSectionValChange}
                                />
                                <label htmlFor="timer"> Time (In Minutes) </label>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 ">

                      <div
                        className=" select-none"
                        id="enableOptinal"
                        name="optional_enable"
                        onClick={handleOptinalBtn}
                      >
                        {sectionData.optional_enable === 1 ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3"></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3"></span>
                        )}
                        <span>Enable Optional</span>
                      </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-6">
                          {sectionData.optional_enable == 1 && (
                            <div className="form-floating form-floating-outline dropdown-with-arrow">
                              <select
                                className="form-control mb-0"
                                name="optional_for"
                                id="optional_for"
                                value={sectionData.optional_for || "any"}
                                onChange={handleSectionValChange} // Pass updated value to state
                              >
                                <option value="first">First</option>
                                <option value="any">Any</option>
                              </select>
                            </div>
                          )}

                        </div>
                        <div className="col-sm-6">
                          {
                            sectionData.optional_enable == 1 && (
                              <div className="">
                                <input
                                  style={{ padding: "11px 10px" }}
                                  type="number"
                                  className="form-control"
                                  min={1}
                                  name="optional_number"
                                  placeholder="number"
                                  value={sectionData.optional_number}
                                  onChange={handleSectionValChange} // Pass updated value to state
                                />

                              </div>
                            )
                          }

                        </div>
                      </div>
                      {
                        sectionData.optional_enable == 1 && (
                          <div className="">
                            <input
                              style={{ padding: "11px 5px", marginTop: "10px", width:"690px" }}
                              type="text"
                              className="form-control"
                              name="optional_instruction"
                              placeholder="Enter Instruction"
                              value={sectionData.optional_instruction}
                              onChange={handleSectionValChange} // Pass updated value to state
                            />

                          </div>
                        )
                      }
                    
                  </>
                )}
              </div>
              <div className="d-flex justify-content-end py-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => handleEditSectionBtn(sectionData.esid)}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewMcqs;
